import { AxiosRequestConfig } from 'axios';

const config: AxiosRequestConfig = {
  headers: { 'Content-Type': 'application/json' },
  responseType: 'json',
};

export default config;
